import { BaseCaller } from "./api";

export default class ClientApi {
  private caller: BaseCaller;

  constructor(caller: BaseCaller) {
    this.caller = caller;
  }

  public list(): Promise<any> {
    return this.caller.get("client/");
  }

  save(data: {
    id: string;
    name: string;
    document: string;
    email: string;
    phone: string;
    address: string;
  }) {
    if (data.id) {
      return this.caller.put(`client/${data.id}`, data);
    }
    return this.caller.post("client/", data);
  }

  updateLocation(data: any): Promise<any> {
    return this.caller.put(`me/address/${data.id}`, data);
  }

  public filter(search: string) {
    const squery =
      search.trim().toUpperCase().length > 0
        ? `?search=${search.trim().toUpperCase()}`
        : "";
    return this.caller.get(`client/filter${squery}`);
  }
}



// WEBPACK FOOTER //
// ./src/api/client-api.ts